export default __webpack_public_path__ + "static/KeywordResearch_02_04-1caecc8cd1c2bdfda203d284b7bff5a8.webp";